import React from 'react'
import { Outlet } from 'react-router-dom'
import '../../Mobile.css'
import './styles/CustomFood.css'

function CustomFood() {
  return (
    <Outlet />
  )
}

export default CustomFood